import FeatureWhiteList from '../../settings/FeatureWhiteList';
import { VerifyLicenseKeyResponse } from '../types';

class FeatureMapper {
  static mapDAOtoFeatureWhitelist(
    response: Omit<VerifyLicenseKeyResponse, 'ht_license_key'>
  ) {
    const featureWhiteList = new FeatureWhiteList();

    featureWhiteList.enableDisableColumnHeaderProcessing(
      response.plan_detail.features.disable_column_header_processing
    );
    featureWhiteList.enableMultiLangFuzzyMatching(
      response.plan_detail.features.fuzzy_matching
    );
    featureWhiteList.enableI18nOverrides(response.plan_detail.features.i18n);
    featureWhiteList.enableMultiFileUpload(
      response.plan_detail.features.multiple_file_upload
    );
    featureWhiteList.enableReuseMapping(
      response.plan_detail.features.remember_mapping
    );
    featureWhiteList.enableAutomaticMapping(
      response.plan_detail.features.automatic_mapping,
      response.plan
    );
    featureWhiteList.setEnableDataHandler(
      response.plan_detail.features.data_handler,
      response.plan
    );

    if (response.plan_detail.upload_size_limit === 0) {
      featureWhiteList.setFileSizeUnlimited();
    } else {
      featureWhiteList.setMaxFileSizeInMb(
        response.plan_detail.upload_size_limit
      );
    }

    featureWhiteList.enableAdvancedParsing(
      response.plan_detail.features.advanced_parsing,
      response.plan
    );
    featureWhiteList.setDefaultLanguage(response.default_language ?? 'en');
    featureWhiteList.setDynamicImport(
      response.plan_detail.features.dynamic_import,
      response.plan
    );
    featureWhiteList.setCustomStyling(
      response.plan_detail.features.custom_style,
      response.plan
    );
    featureWhiteList.setEnableLogs(response.plan_detail.features.logs);
    featureWhiteList.setLoading(false);
    featureWhiteList.setLocale(response.locale || {});
    featureWhiteList.setRowsLimit(
      response.plan_detail.sdk_rows_limit ?? undefined
    );
    featureWhiteList.setEnableSmartTable(
      response.plan_detail.features.smart_table || false
    );

    return featureWhiteList;
  }

  static getEmptyFeatureWhitelist() {
    const featureWhiteList = new FeatureWhiteList();
    featureWhiteList.setLoading(false);
    return featureWhiteList;
  }
}

export default FeatureMapper;
